function checkPermission(el, binding, vnode) {
  const { value } = binding;
  const store = vnode.context && vnode.context.$store;
  if (!value) {
    return;
  }
  const allowed = store && store.getters.hasPermission(value);
  if (!allowed && el.parentNode) {
    el.parentNode.removeChild(el);
  }
}

export default {
  inserted(el, binding, vnode) {
    checkPermission(el, binding, vnode);
  },
  update(el, binding, vnode) {
    checkPermission(el, binding, vnode);
  },
};
